const Hero = () => {
  return (
    <div className="bg-gradient-to-b from-[#F4FAF9] to-white py-24 md:py-32">
      <div className="container mx-auto px-4 max-w-6xl">
        
        {/* Logo Area */}
        <div className="mb-12 text-center">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-[#0C7779] flex items-center justify-center">
              <span className="text-white font-bold text-lg">G</span>
            </div>
            <span className="text-2xl font-bold text-[#0F172A]">GrowOn</span>
          </div>
          <div className="text-[#0C7779] text-sm font-medium tracking-wide uppercase">
            MENTORSHIP COMMUNITY
          </div>
        </div>

        {/* Main Content */}
        <div className="text-center max-w-3xl mx-auto mb-10">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#0F172A] mb-6 leading-tight">
            Career guidance from
            <span className="block mt-3 text-[#0C7779]">industry practitioners</span>
          </h1>
          <p className="text-xl text-[#64748B] leading-relaxed">
            Connect with working professionals for honest advice, portfolio reviews, 
            and real-world project guidance.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-20">
          <a 
            href="/community" 
            className="px-8 py-3 bg-[#249E94] text-white rounded-lg font-semibold hover:bg-[#1D867C] transition-colors duration-200 text-center"
          >
            Join the community
          </a>
          <a 
            href="/mentors" 
            className="px-8 py-3 bg-white text-[#0C7779] rounded-lg font-semibold hover:bg-[#F4FAF9] transition-colors duration-200 text-center border border-[#E2EFEA]"
          >
            Browse mentors
          </a>
        </div>

        {/* Stats */}
        <div className="border-t border-[#E2EFEA] pt-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-2xl mx-auto">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#0C7779] mb-2">500+</div>
              <div className="text-[#64748B] text-sm uppercase tracking-wider">Active Students</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#0C7779] mb-2">15+</div>
              <div className="text-[#64748B] text-sm uppercase tracking-wider">Industry Mentors</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#0C7779] mb-2">92%</div>
              <div className="text-[#64748B] text-sm uppercase tracking-wider">Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;